<script lang="ts">
    import { Dialog, Dot, H3 } from "attractions";
    import Purchase from "../../../Models/Purchase";
    import { LATEST_PURCHASE_WITH_CLEARANCE_ACTION } from "../../../Stores/Purchase";

    export let currentAction;
    export let purchase;

    async function sendClearanceConfirmationRequest() {
        const res = await Purchase.clearancePurchase(purchase);
        if (res) {
            LATEST_PURCHASE_WITH_CLEARANCE_ACTION.set(purchase);
            currentAction = null;
        }
    }

    async function sendRemoveConfirmationRequest() {
        const res = await Purchase.remove(purchase);
        if (res) {
            LATEST_PURCHASE_WITH_CLEARANCE_ACTION.set(purchase);
            currentAction = null;
        }
    }

    function cancelAction() {
        currentAction = null;
    }
</script>

{#if currentAction == 'clearanceConfirmation'}
    <Dialog class="confirmationDialog" title="Potwierdzenie">
        <H3 style="font-size: 1rem;">Czy chcesz rozliczyć ten zakup? Tej operacji nie można cofnąć.</H3>
        <section class="actions">
            <small class="actionButton" on:click={sendClearanceConfirmationRequest}><Dot small style="margin-right: .25rem" /> Tak, jest w porządku</small>
            <small class="actionButton" on:click={cancelAction}><Dot danger small style="margin-right: .25rem" /> Anuluj</small>
        </section>
    </Dialog>
{/if}

{#if currentAction == 'deleteConfirmation'}
    <Dialog class="confirmationDialog" title="Potwierdzenie" danger>
        <H3 style="font-size: 1rem;">Czy chcesz usunąć ten zakup? Zostanie on również usunięty z konta pracownika. Tej operacji nie można cofnąć.</H3>
        <section class="actions">
            <small class="actionButton" on:click={sendRemoveConfirmationRequest}><Dot small danger style="margin-right: .25rem" /> Tak, potwierdzam</small>
            <small class="actionButton" on:click={cancelAction}><Dot small style="margin-right: .25rem" /> Anuluj</small>
        </section>
    </Dialog>
{/if}

<style lang="scss">
    .actions {
        display: flex;

        .actionButton {
            margin: {
                left: .5rem;
                top: .5rem;
            }
            display: flex;
            align-items: center;
            font-size: .75rem;
            cursor: pointer;

            &:first-of-type {
                margin-left: 0;
            }
        }
    }
</style>